import { Link } from 'react-router-dom';

export default function CtaSection() {
  return (
    <section className="relative py-16 md:py-20 px-4 md:px-6 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20abstract%20gradient%20background%20with%20rich%20amber%20amber%20gold%20and%20terracotta%20tones%2C%20soft%20glow%20effect%2C%20minimal%20sophisticated%20design%2C%20clean%20artistic%20composition%2C%20professional%20elegant%20texture%2C%20serene%20warm%20atmosphere%2C%20high%20quality%20abstract&width=1400&height=500&seq=cta-bg-yw91&orientation=landscape"
        alt="喑网91 立即探索"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-br from-foreground-900/80 via-foreground-900/70 to-foreground-900/80"></div>
      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <h2
          className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-4"
          style={{ fontFamily: 'var(--font-heading)' }}
        >
          立即体验喑网91的全新服务
        </h2>
        <p className="text-sm md:text-base text-white/70 mb-8 max-w-xl mx-auto leading-relaxed">
          无论您是初次了解喑网91还是老用户，我们始终为您提供最优质的服务体验。立即探索喑网91，感受智能、高效、安全的全新在线生活方式。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/categories"
            className="px-8 py-3.5 rounded-full bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap"
          >
            探索功能分类
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 rounded-full border border-white/30 text-white font-medium text-sm hover:bg-white/10 transition-all duration-200 whitespace-nowrap"
          >
            联系我们
          </Link>
        </div>
      </div>
    </section>
  );
}